import type {
    AnalyticsProperties,
    AnalyticsProvider,
    PageViewProperties,
} from '../types';

/**
 * Silent provider used internally when analytics is disabled or init fails.
 * Not a configurable option — use REACT_APP_ANALYTICS_ENABLED=false instead.
 */
export class NoopProvider implements AnalyticsProvider {
    readonly name = 'noop' as const;

    initialize(): void {
        // no-op
    }

    track(_event: string, _properties?: AnalyticsProperties): void {
        // no-op
    }

    pageView(
        _path: string,
        _properties?: Partial<PageViewProperties> & AnalyticsProperties
    ): void {
        // no-op
    }
}
